import { useState } from "react";
import { faqs } from "@/mocks/portal";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[0.8fr_1.6fr]">
          <div>
            <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
              <i className="ri-question-answer-line text-sm" aria-hidden="true" />
              FAQ
            </span>
            <h2 className="mt-1 text-lg font-bold text-foreground-950 md:text-2xl">关于“哪个好用”的常见疑问</h2>
            <p className="mt-2 text-[13px] leading-6 text-foreground-600">
              线路对比与速度测试参考之外，这些高频问题能帮你把结论串起来。
            </p>
            <div className="mt-4 flex flex-wrap gap-2 text-[12px]">
              <span className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-foreground-600">延迟 &amp; 可用性</span>
              <span className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-foreground-600">晚高峰选线</span>
              <span className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-foreground-600">多线切换</span>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.q} className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left"
                    aria-expanded={isOpen}
                  >
                    <span className="text-sm font-bold text-foreground-950">{f.q}</span>
                    <span
                      className={`grid h-7 w-7 shrink-0 place-items-center rounded-full transition-colors ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-sm`} aria-hidden="true" />
                    </span>
                  </button>
                  {isOpen && <p className="border-t border-background-200 px-4 py-4 text-[13px] leading-7 text-foreground-600">{f.a}</p>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}